export const costTypeOptions = [
    { value: 'costperplay', text: 'Cost Per Play (CPP)' },
    { value: 'costperday', text: 'Cost Per Day (CPD)' },
    { value: 'costperclick', text: 'Cost Per Click (CPC)' },
    { value: 'costperunit', text: 'Cost Per Unit (CPU)' },
    { value: 'costpercontact', text: 'Cost Per Lead (CPL)' },
    { value: 'costpermille', text: 'Cost Per Mille (CPM)' }
];




export function costTypeOptionsToObject(options) {
    return options.reduce((acc, { value, text }) => {
        acc[value] = text;
        return acc;
    }, {});
}